import React from "react";
import { FAQ } from "@/data/site";
import PageHero from "@/components/PageHero";
import Breadcrumb from "@/components/Breadcrumb";
import NewsletterSection from "@/components/NewsletterSection";

export default function Faq() {
  return (
    <>
      <PageHero tag="Aide" title="Questions <em>fréquentes</em>" subtitle="Tout ce que vous devez savoir sur nos produits, la livraison et nos engagements." />
      <Breadcrumb trail={[{ label: "Accueil", to: "/" }, { label: "FAQ" }]} />

      <section className="prose-section">
        <div className="faq-list" data-testid="faq-list">
          {FAQ.map((item, i) => (
            <details className="faq-item" key={i} data-testid={`faq-item-${i}`}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
        </div>
      </section>

      <NewsletterSection />
    </>
  );
}
